var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',_vm._l((_vm.productListByTopic(_vm.topic.index)),function(p){return (p.points > 0)?_c('div',{key:p.col,staticClass:"product-in-topic"},[_c('product-bar-in-topic',{attrs:{"product":p}})],1):_vm._e()}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }